import { PropsWithChildren } from 'react';

interface ISectionContainer {
  border?: boolean;
}

export const SectionConatiner: React.FC<
  PropsWithChildren<ISectionContainer>
> = ({ children, border = true }) => {
  const borderClass = border ? 'border-b-sm border-grey-300' : '';
  return <section className={`py-20 ${borderClass}`}>{children}</section>;
};
